"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverColumnHeaderMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var icons_1 = require("@material-ui/icons");
var core_1 = require("@material-ui/core");
var ColumnOptionsMenu_1 = require("../ColumnOptionsMenu");
var icons_2 = require("../../icons");
var atoms_1 = require("../../atoms");
var styles_1 = __importDefault(require("./styles"));
exports.PopoverColumnHeaderMenu = react_1.default.memo(function (_a) {
    var id = _a.id, title = _a.title, columnOptionsMenuProps = _a.columnOptionsMenuProps, on = _a.on;
    var _b = (0, react_1.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, __assign({ id: "".concat(id, "ShowColumnOptionsButton"), className: classes.button, variant: "text", onClick: anchorEl ? handleClose : handleClick, endIcon: on ? ((0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ simple: true, isSelected: true, size: "small", className: classes.icon }, { children: (0, jsx_runtime_1.jsx)(icons_2.Filter, {}) }))) : ((0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ size: "small", className: classes.icon }, { children: (0, jsx_runtime_1.jsx)(icons_1.FilterList, {}) }))) }, { children: title })), open && ((0, jsx_runtime_1.jsx)(ColumnOptionsMenu_1.ColumnOptionsMenu, __assign({ anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                } }, columnOptionsMenuProps, { anchorEl: anchorEl, open: open, onClose: handleClose, 
                // FIXME: causing the whole thing to close because button is outside of the on click away wrapper
                // onClickAway={handleClose}
                idPrefix: id })))] }));
});
